import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';

const RESOURCE = '/subscriptions/service-plan/:servicePlanId/service-plan-terms/:planTermId/';

type QueryFnType = typeof queryFn;

interface DTO {
    servicePlanId: string;
    planTermId: string;
}
const queryFn = ({ servicePlanId, planTermId }: DTO): Promise<ServicePlanTerm> => {
    return axios.get(formatResourcePath(RESOURCE, { servicePlanId, planTermId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetServicePlanTerm,  RESOURCE as SERVICE_PLAN_TERM_RESOURCE };
